import { render } from "./FacebookStoryReview.vue?vue&type=template&id=444c81b3&scoped=true"
import script from "./FacebookStoryReview.vue?vue&type=script&lang=js"
export * from "./FacebookStoryReview.vue?vue&type=script&lang=js"

import "./FacebookStoryReview.vue?vue&type=style&index=0&id=444c81b3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444c81b3"]])

export default __exports__